// @ts-strict-ignore
import type { ReactElement } from "react";
import React from "react";
import type { CurrencyType } from "types/converter";
import { ButtonIconContainer, StyledInput } from "../styles";
import { checkForUSDStableCoin, isCryptoSymbol } from "../../utils";
import { Button, CryptoIcon, FiatIcon } from "@hubble/web";
import type { SupportedCurrencies } from "@hubble/web/dist/esm/components/visual-elements/FiatIcon/constants";
import { useConverterPageContext } from "utils/converter-provider";

interface CurrencyInputProps {
  testId: string;
  name: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  shouldShowLoader: boolean;
  currency: CurrencyType;
  onCurrencySelectionClick: () => void;
  exchangeRate?: number;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  testId,
  name,
  value,
  onChange,
  shouldShowLoader,
  currency,
  onCurrencySelectionClick,
  exchangeRate
}) => {
  const { isRouting } = useConverterPageContext();

  const renderIconElement = (
    currency: CurrencyType,
    exchangeRate?: number
  ): ReactElement => {
    if (!exchangeRate) {
      return null;
    }

    return (
      <ButtonIconContainer>
        {!!exchangeRate ? (
          isCryptoSymbol(currency.symbol?.toLowerCase()) ||
          checkForUSDStableCoin(currency.symbol?.toLowerCase()) ? (
            <CryptoIcon size="sm" symbol={currency.symbol} />
          ) : (
            <FiatIcon
              size="sm"
              symbol={currency.symbol as SupportedCurrencies}
            />
          )
        ) : null}
      </ButtonIconContainer>
    );
  };
  return (
    <StyledInput
      data-testid={testId}
      name={name}
      type="number"
      min={0}
      inputSize="lg"
      value={value}
      onChange={onChange}
      leftElement={
        <Button.Secondary
          data-testid={`${testId}-currency-selection-trigger`}
          style={{ padding: "8px 10px 8px 8px" }}
          loading={isRouting && shouldShowLoader}
          disabled={isRouting}
          leftElement={renderIconElement(currency, exchangeRate)}
          onClick={onCurrencySelectionClick}
        >
          {currency.symbol}
        </Button.Secondary>
      }
    />
  );
};

export default CurrencyInput;
